import { ModalsKey } from '@/enums/modalsKey';
import { GameReportType } from '@/hooks/gameReport/useGameReportSearchParams/gameReportType.enum';
import { Decimal } from '@starsoft/common/services/Decimal';
import { memo } from 'react';
import LastMatchChip from '../../../LastMatches/Chip';
import { LastBetChipProps } from './props';

function LastBetChip({ bet, isLoading, cover, gameId }: LastBetChipProps) {
  return (
    <LastMatchChip
      link={`?bet-slug=${bet?.slug}&game-id=${gameId}&game-type=${GameReportType.BetGame}`}
      won={bet?.payout?.isPositive()}
      isLoading={isLoading}
      modal={ModalsKey.GameReport}
      cover={cover}
    >
      {!isLoading &&
        Decimal.fromSubunits(String(bet?.multiplier), {
          scale: 4,
        }).toNumberString()}
      x
    </LastMatchChip>
  );
}

export default memo(LastBetChip);
